export const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
  
    if (totalPages <= 1) return null; // Hide pagination if only one page
  
    return (
      <div className="flex justify-center mt-8 space-x-2">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => onPageChange(i + 1)}
            className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 shadow-md 
              ${
                currentPage === i + 1
                  ? "bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg scale-105"
                  : "bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gradient-to-r hover:from-blue-200 hover:to-indigo-300 hover:text-gray-900"
              }`}
          >
            {i + 1}
          </button>
        ))}
      </div>
    );
  };
  